import { create } from "zustand";

export const useVulnerabilityStore = create((set) => ({
    items: [],
    loading: false,
    error: null,
    selectedItem: null,
    columnFilters: {},
    uniqueValues: {},
    paginationData: {
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0,
        totalPages: 0,
    },
    isFormOpen: false,
    isEditMode: false,
    isDeleteDialogOpen: false,
    itemToDelete: null,
    isDetailsOpen: false,
    selectedDetailsItem: null,

    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
    setItems: (items) => set({ items }),
    setSelectedItem: (selectedItem) => set({ selectedItem }),
    setColumnFilters: (columnFilters) => set({ columnFilters }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues }),
    setPaginationData: (data) => set((state) => ({
        paginationData: {
            ...state.paginationData,
            ...data,
            currentPage: data.page || data.currentPage || state.paginationData.currentPage,
            itemsPerPage: data.pageSize || data.itemsPerPage || state.paginationData.itemsPerPage,
            totalItems: data.total || data.totalItems || state.paginationData.totalItems,
            totalPages: data.totalPages || state.paginationData.totalPages,
        },
    })),
    openCreateForm: () => set({ isFormOpen: true, isEditMode: false, selectedItem: null, error: null }),
    openEditForm: (item) => set({ isFormOpen: true, isEditMode: true, selectedItem: item, error: null }),
    closeForm: () => set({ isFormOpen: false, selectedItem: null, error: null }),
    openDeleteDialog: (item) => set({ isDeleteDialogOpen: true, itemToDelete: item, error: null }),
    closeDeleteDialog: () => set({ isDeleteDialogOpen: false, itemToDelete: null }),
    openDetailsDialog: (item) => set({ isDetailsOpen: true, selectedDetailsItem: item, error: null }),
    closeDetailsDialog: () => set({ isDetailsOpen: false, selectedDetailsItem: null }),
}));
